import { Table, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { useListEventTypesQuery } from './eventTypesApi';
import Loading from '../../app/components/Loading';
import getClippedText from '../../app/utils/getClippedText';

const COLUMNS = ['ID', 'Name', 'Description', 'Actions'];

function EventTypesList() {
  const { isFetching, data: eventTypes = [], isError } = useListEventTypesQuery();

  if (isFetching) {
    return <Loading text="Loading event types list" />;
  }

  return (
    <main>
      <div className="mb-4">
        <h1>Event types</h1>
      </div>

      {isError && <Alert variant="danger">An error occured while fetching the event types list</Alert>}

      <Table striped bordered hover responsive>
        <thead>
          <tr>
            {COLUMNS.map((column, index) => (
              <th className="col-min" key={index}>
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {eventTypes.map((eventType) => (
            <tr key={eventType.id}>
              <td className="col-min">{eventType.id}</td>
              <td className="col-min">{getClippedText(eventType.name)}</td>
              <td className="col-min">{getClippedText(eventType.description, 80)}</td>
              <td>
                <Link to={`/event-types/${eventType.id}`}>Edit</Link>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </main>
  );
}

export default EventTypesList;
